import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';

import { getEditRoutePathParams } from '~/routes/helpers';
import { envConfigSelectors } from '~/components';

import { getDisplayName, isEmpty } from '../../utils';
import { setEditMode } from '../../routes/edit/common/edit-appointment.actions';

export const mapStateToProps = (state) => {
  const {
    appointment: {
      draft: {
        appointmentType: { id: appointmentTypeId },
      },
    },
    editAppointment: { temporaryAppointment },
  } = state;
  return {
    firstEditPagePath: envConfigSelectors.selectFirstEditPage(appointmentTypeId)(state),
    temporaryAppointment,
  };
};

const mapDispatchToProps = {
  dispatchSetEditMode: setEditMode,
};

export const withEditMode = () => (Component) =>
  class extends PureComponent {
    static propTypes = {
      history: PropTypes.shape({}).isRequired,
      temporaryAppointment: PropTypes.shape({}).isRequired,
      dispatchSetEditMode: PropTypes.func.isRequired,
      firstEditPagePath: PropTypes.string.isRequired,
    };

    static displayName = `WithEdit(${getDisplayName(Route)})`;

    componentDidMount() {
      const { firstEditPagePath, history, temporaryAppointment, dispatchSetEditMode } = this.props;

      if (isEmpty(temporaryAppointment)) {
        const {
          location: { pathname },
        } = history;
        const {
          params: { appointmentId },
        } = getEditRoutePathParams(pathname);
        if (pathname.indexOf(firstEditPagePath) === -1) {
          history.replaceWithToken({
            pathname: appointmentId ? `/${appointmentId}${firstEditPagePath}` : firstEditPagePath,
          });
        }
      }
      dispatchSetEditMode(true);
    }

    render() {
      const { ...routeProps } = this.props;
      return <Route {...routeProps} render={(props) => <Component {...props} {...routeProps} />} />;
    }
  };

export const ConnectedWithEditMode = () => (Component) =>
  withRouter(connect(mapStateToProps, mapDispatchToProps)(withEditMode()(Component)));
